import { Injectable } from '@angular/core';

import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { MainApi } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GRpcRequestType } from '../grpc-class.type';
import { GrpcCommonService } from './common.service';

export type IUpdateWomanHealth = GRpcRequestType<MainApi.UserMedcardGrpcContractClient['UpdateWomanHealth']>;
export type IUpdate = GRpcRequestType<MainApi.UserMedcardGrpcContractClient['Update']>;

@Injectable()
export class UserMedcardGrpcContractService extends GrpcCommonService<MainApi.UserMedcardGrpcContractClient> {
  constructor(protected _GrpcContract: MainApi.UserMedcardGrpcContractClient) {
    super();
  }

  updateWomanHealth(request: IUpdateWomanHealth) {
    return from(
      this._GrpcContract.UpdateWomanHealth(new MainApi.UpdateWomanHealthWpcRequest(request), this.getMetadata()),
    ).pipe(grpcOperator());
  }

  update(request: IUpdate) {
    return from(
      this._GrpcContract.Update(new MainApi.MedcardWpc(MainApi.MedcardWpc.fromObject(request)), this.getMetadata()),
    ).pipe(grpcOperator());
  }
}
